export const offerGroupsListPathName = 'offer-groups';
export const closureCausePathName = 'closure-cause';
export const placementPurposePathName = 'placement-purpose';
export const recruitmentRequestInformationTypesPathName = 'recruitment-request-information-types';
export const recruitmentCollaborationPathName = 'recruitment-collaboration';
export const serviceTargetTypePathName = 'service-target-type';
export const forumFeedbackPathName = 'forum-feedback';
